import React from "react";
import "./pic.css"

function Pic() {
  return (
    <div className="pic">
      {/* <img
        src={process.env.PUBLIC_URL + "/pride2.jpg"}
        className="picture"
      ></img> */}

      // <h1 style={{ position: "relative", top: "5rem", color: "white", textAlign: "center" }}>Every time someone steps up and says who they are, <br /> the world becomes a better, <br /> more interesting place. <br /><br /><br />  Captain Raymond Holt</h1>
    </div>
  );
}

export default Pic;
